import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
declare global {
  interface Window {
    nonce?: any
  }
}

const setBrandColor = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const rootStyle = getComputedStyle(document.documentElement)

    if (!rootStyle.getPropertyValue('--brand-color').trim()) {
      document.documentElement.style.setProperty('--brand-color', '#1d3557')
    }

    if (!rootStyle.getPropertyValue('--brand-text-color').trim()) {
      document.documentElement.style.setProperty(
        '--brand-text-color',
        '#1d3557',
      )
    }
  })
}

setBrandColor()

const root = ReactDOM.createRoot(
  document.getElementById('render-form') as HTMLElement,
)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
